import { render, staticRenderFns } from "./DecidedProposals.vue?vue&type=template&id=7f41cf24&scoped=true&"
import script from "./DecidedProposals.vue?vue&type=script&lang=js&"
export * from "./DecidedProposals.vue?vue&type=script&lang=js&"
import style0 from "./DecidedProposals.vue?vue&type=style&index=0&id=7f41cf24&prod&lang=css&"
import style1 from "./DecidedProposals.vue?vue&type=style&index=1&id=7f41cf24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f41cf24",
  null
  
)

export default component.exports